<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row>
        <v-col>
          <h3>{{ $t("messages.resendBillingMail") }}</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>{{ $t("messages.resendBillingMailText") }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn large block flat class="primaryButton" :loading="loading" @click="confirm()" ref="confirmButton"
            style="width: 100%">
            <span>{{ $t("basics.confirm") }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "billWarningDrawer",
  props: ["refreshDisplay", "billData"],
  emits: ["close"],

  data() {
    return {
      loading: false
    };
  },

  components: {
  },


  methods: {
    async confirm() {
      if(!this.billData){
        return 
      }
      
      this.loading = true
      this.axios.post(this.axios.defaults.baseURL + "user/bills/resend/", {
        id: this.billData.id,
        send_mail: true
      })
        .then(() => {
          this.$emit("close", 1)
          this.loading = false
        })
        .catch((e) => {
          console.log(e)
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
          this.loading = false
        })
    },
  },

  mounted() { },
};
</script>
